var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('avue-form',{ref:"form",attrs:{"option":_vm.option},on:{"reset-change":_vm.emptytChange,"submit":_vm.submit},model:{value:(_vm.obj),callback:function ($$v) {_vm.obj=$$v},expression:"obj"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c32b3c46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wx/refund.vue
// module id = null
// module chunks = 